// @flow
import styled from "styled-components"

export const StyledWrap = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 0 4rem 0 4rem;
  margin-bottom: 2rem;
`



// WEBPACK FOOTER //
// ./src/modals/SubscribePlan/PromocodeInput/styled.js